import React from 'react';
import { Button } from '@mui/material';
import { MdAdd } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

export default function AddButton({ text, route, disabled }) {
  const navigate = useNavigate();

  return (
    <Button
      type="submit"
      variant="contained"
      sx={{ backgroundColor: '#00043C', '&:hover': { backgroundColor: '#00043C' } }}
      onClick={() => navigate(route)}
      disabled={disabled}
    >
      <MdAdd />
      {text}
    </Button>
  );
}
